import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AllReformAreasRoutingModule } from './all-reform-areas-routing.module';
import { DashboardPageComponent } from './components/dashboard-page/dashboard-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from 'src/app/material.module';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { ScoreGenerateModalComponent } from './components/admin-dashboard/score-generate-modal/score-generate-modal.component';


@NgModule({
  declarations: [DashboardPageComponent, AdminDashboardComponent, ScoreGenerateModalComponent],
  imports: [
    CommonModule,
    AllReformAreasRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ],
})
export class AllReformAreasModule { }
